import {useTranslation} from 'react-i18next'
import {camelize} from 'humps'

import paymentMethodPropType from '~/utils/propTypes/paymentMethod'
import getPaymentMethodLogo from '../../utils/paymentMethodLogo'

import DrawerFieldItem from './DrawerFieldItem'
import DrawerSection from './DrawerSection'

const PaymentMethodSection = ({paymentMethod}) => {
  const {t} = useTranslation('pointsOnPayments')

  const paymentMethodType = camelize(paymentMethod.type)
  const paymentMethodDetails = paymentMethod[paymentMethodType]

  return (
    <DrawerSection
      title={t(
        'pointsOnPayments:pointsOnPayment.drawer.paymentMethodSectionTitle',
      )}
      logo={getPaymentMethodLogo(paymentMethodDetails, {
        height: '25px',
        width: 'fit-content',
      })}
    >
      {paymentMethodType === 'debitAgreement' && (
        <>
          <DrawerFieldItem
            label={t(
              'pointsOnPayments:pointsOnPayment.drawer.fields.branchCode',
            )}
            value={paymentMethodDetails.branchCode}
          />
          <DrawerFieldItem
            label={t(
              'pointsOnPayments:pointsOnPayment.drawer.fields.accountNumber',
            )}
            value={paymentMethodDetails.accountNumber}
          />
        </>
      )}
    </DrawerSection>
  )
}

PaymentMethodSection.propTypes = {
  paymentMethod: paymentMethodPropType.isRequired,
}

export default PaymentMethodSection
